<div *ngIf="selectedEntity">
  <div *ngIf="company" class="company" title="Search within this company">
    <img class="selectedImage" src="../../assets/images/settings/company.svg">{{company.name}} ({{company.id}})
    <span class="company__search" (click)="searchWithinCompany()"></span>
  </div>

  <ul>
    <ng-container *ngFor="let entity of selectedEntity.path; let last = last; let index = index;">
      <img *ngIf="last" class="selectedImage" [src]="getIcon(entity.entityType)">
      <li *ngIf="entity.entityType !== 'Company'" [class.selected]="last">
        <span (click)="selectBreadcrumb(entity);" [class.highlighted]="highlightedEntityId === entity.id">
          <ng-container [ngSwitch]="entity.entityType">
            <ng-container *ngSwitchCase="'Default'">
              Lytx
            </ng-container>
            <ng-container *ngSwitchCase="'Stack'">
              Stack {{entity.id}}
            </ng-container>
            <ng-container *ngSwitchCase="'Group'">
              <!-- If entity before us is company, this means we are at root group. We want to display company name before root group -->
              <ng-container *ngIf="selectedEntity.path[index - 1].entityType === 'Company'">
                ({{selectedEntity.path[index - 1].name}})
              </ng-container>
              {{entity.name}}
            </ng-container>
            <ng-container *ngSwitchDefault>
              {{entity.name}}
            </ng-container>
          </ng-container>
        </span>
        <span *ngIf="!last" class="arrow">></span>
      </li>
    </ng-container>
  </ul>
</div>
